import { render, staticRenderFns } from "./EditorMobileGuard.vue?vue&type=template&id=448b3a1c"
import script from "./EditorMobileGuard.vue?vue&type=script&lang=js"
export * from "./EditorMobileGuard.vue?vue&type=script&lang=js"
import style0 from "./EditorMobileGuard.vue?vue&type=style&index=0&id=448b3a1c&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports